<ng-container>
  <div class="fab-nav-container" [class.open]="isOpen" appFreeDragging>
    <!-- add on outer container ng-container and another componente used as search tool
    add tooltip to all buttons

    here directive to drag element
    https://angularindepth.com/posts/1396/drag-drop-directive

    badge on search counts
    fab mini buttons or radio to filter by type-->
    <div class="fab-buttons-col">
      <button
        mat-mini-fab
        [routerLink]="['/cards']"
        [queryParams]="{ card: 0 }"
        matTooltip="Oggetti artistici"
        matTooltipPosition="before"
        style="background-color: #00695c; --n: 2"
      >
        OA
      </button>

      <button
        mat-mini-fab
        [routerLink]="['/collections']"
        matTooltip="Collezioni"
        matTooltipPosition="before"
        style="background-color: #00695c; --n: 2"
      >
        C
      </button>

      <button
        mat-mini-fab
        matTooltip="Fotografie"
        matTooltipPosition="before"
        style="background-color: #0288d1; --n: 1"
        [routerLink]="['/cards']"
        [queryParams]="{ card: 2 }"
      >
        F
      </button>
      <button
        mat-mini-fab
        matTooltip="Stampe"
        matTooltipPosition="before"
        style="background-color: #00838f; --n: 3"
        [routerLink]="['/cards']"
        [queryParams]="{ card: 1 }"
      >
        S
      </button>
      <button
        mat-mini-fab
        matTooltip="Matrici incise"
        matTooltipPosition="before"
        style="background-color: #0277bd; --n: 4"
        [routerLink]="['/cards']"
        [queryParams]="{ card: 3 }"
      >
        M
      </button>
      <button
        mat-mini-fab
        matTooltip="Disegni"
        matTooltipPosition="before"
        style="background-color: #004d40; --n: 5"
        [routerLink]="['/cards']"
        [queryParams]="{ card: 4 }"
      >
        D
      </button>
      <button
        mat-mini-fab
        matTooltip="Basi"
        matTooltipPosition="before"
        style="background-color: #006064; --n: 6"
        [routerLink]="['/base']"
      >
        B
      </button>
      <button
        mat-mini-fab
        [class.disabled]="!searchReady"
        matTooltip="Cerca"
        matTooltipPosition="before"
        (click)="toggleSearchOpen()"
        style="background-color: #01579b; --n: 7"
      >
        <mat-icon>search</mat-icon>
      </button>
    </div>

    <button
      (click)="toggleIsOpen()"
      (mouseenter)="onMouseEnter()"
      mat-fab
      color="primary"
      aria-label="Example icon button with a menu icon"
    >
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <div class="search-panel-container" *ngIf="searchIsOpen">

    <div class="collections-list" *ngIf="selectedCards.length>0">
      <button mat-raised-button *ngIf="selectedCollections.length>0"
              (click)="addToCollections()">Aggiungi alle collezioni selezionate
        <mat-spinner diameter="20" *ngIf="addingToCollection"></mat-spinner></button>
      <button
        mat-raised-button
        *ngIf="selectedCollections.length>0"
        (click)="deselectAllCollections()"
        style="margin: 10px 16px;">
        {{ 'Deseleziona tutto' | translate }}
      </button>
      <mat-selection-list
        [multiple]="true"
        (selectionChange)="handleCollectionsListSelectionChange($event)"
        [(ngModel)]="selectedCollections"
      >
        <div mat-subheader>Collezioni</div>
        @for (collection of collections(); track collection.id) {
          <mat-list-option  [value]="collection">{{ collection.titolo }}</mat-list-option>
        }
      </mat-selection-list>
    </div>
    <div class="search-panel">
      <div class="search-toolbar">
        <div class="text-search">
          <mat-button-toggle-group [(ngModel)]="selectedCardType" (change)="handleCardTypeChange($event.value)" 
                                   style="background-color:white; margin-bottom: 10px;">
            <mat-button-toggle value="oa">OA</mat-button-toggle>
            <mat-button-toggle value="f">F</mat-button-toggle>
            <mat-button-toggle value="s">S</mat-button-toggle>
            <mat-button-toggle value="d">D</mat-button-toggle>
            <mat-button-toggle value="mi">MI</mat-button-toggle>
            <mat-button-toggle value="all">Tutti</mat-button-toggle>
          </mat-button-toggle-group>
          <mat-radio-group style="background-color:white; margin-bottom: 5px; padding: 0 10px;" [(ngModel)]="searchType"
                           (change)="handleSearchTypeChange($event)"
                           aria-label="Select an option">
            <mat-radio-button value="text">full text</mat-radio-button>
            <mat-radio-button value="tokens">tokens</mat-radio-button>
          </mat-radio-group>
          <mat-form-field
            style="width:90%"
            [matBadge]="searchResults.length"
            matBadgePosition="before"
            matBadgeColor="accent"
          >
            <mat-label>Cerca beni</mat-label>
            <input
              matInput
              placeholder="Search"
              (change)="handleTextSearchChanged($event)"
              [value]="searchText"
            />
          </mat-form-field>
        </div>
        <div class="range-search">
          <mat-form-field>
            <mat-label>Prezzo minimo</mat-label>
            <input
              matInput
              placeholder="min"
              type="number"
              (blur)="handleMinPriceChanged($event)"
              [(ngModel)]="minPrice"
            />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Prezzo massimo</mat-label>
            <input
              matInput
              placeholder="max"
              type="number"
              (blur)="handleMaxPriceChanged($event)"
              [(ngModel)]="maxPrice"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="search-results">

        <mat-selection-list
          [multiple]="true"
          [(ngModel)]="selectedCards"
          (selectionChange)="handleListSelectionChange($event)"
        >
          <cdk-virtual-scroll-viewport itemSize="50" class="search-result-virtual">
            <ng-container *cdkVirtualFor="let oa of searchResults">
              <mat-list-option
                [value]="oa"
              >

                <div
                  matListItemLine
                  class="list-option-data"
                  [class.madre]="oa.isParent"
                  [routerLink]="['/cards/' + oa.cardType + '/manager', oa.id]"
                >
                  <span class="list-thumbnail"><img [src]="fileUrl + oa.previewUrl" alt=""></span>
                  <span class="sgt">{{ oa.sgt }} - {{ oa.number }}</span>
                  <span class="mat">{{ oa.material }}</span>
                  <span class="misu">{{ oa.measures }}</span>
                </div>
              </mat-list-option>
            </ng-container>

          </cdk-virtual-scroll-viewport>

        </mat-selection-list>
      </div>
    </div>

  </div>


</ng-container>
